<template>
  <div class="modal fade" tabindex="-1" :id="'contactAddressModal' + id" >
    <div class="modal-dialog modal-md">
      <form @submit.prevent="saveForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="action === 'create'" class="modal-title">{{$t("contacts.new_address")}}</h5>
            <h5 v-if="action === 'edit'" class="modal-title">{{$t("contacts.edit_address")}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="form">
              <div class="row mb-5">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('auth.country') }} </label>
                    <select :name="'country'+id"  :data-dropdown-parent="'#contactAddressModal' + id"  data-search="true" :id="'country'+id"  :data-placeholder="$t('auth.country')" class="form-select form-select-solid kt_select2"
                            data-control="select2" v-model="form.country">
                      <option></option>
                      <option v-for="country in getCountries" :key="country.id" :value="country.id">
                        {{country.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <Select2
                    :parent-id="'#contactAddressModal'+id"
                    containerClass="col-md-6"
                    :name="'contactAddressArea'+id"
                    :multiple="false"
                    :label="$t('contacts.placeholder.area')"
                    labelClass="mb-3"
                    selectClass="form-select form-select-solid"
                    :isRequired="false"
                    :placeholderText="$t('contacts.placeholder.area')"
                    v-model="form.area_id"
                    :IsInputGroup="true"
                    icon="bi bi-plus"
                    :clickAddon="openAreaModal"
                >
                  <option v-for="area in areas" :key="area.id" :value="area.id">
                    {{ area.name }}
                  </option>
                </Select2>
              </div>
              <div class="row mb-5">
                <Select2
                    :parent-id="'#contactAddressModal'+id"
                    containerClass="col-md-6"
                    :name="'contactAddressCity'+id"
                    :multiple="false"
                    :label="$t('auth.city')"
                    labelClass="mb-3"
                    selectClass="form-select form-select-solid"
                    :isRequired="false"
                    :placeholderText="$t('contacts.placeholder.city')"
                    v-model="form.city_id">
                  <option v-for="city in cites" :key="city.id" :value="city.id">
                    {{ city.name }}
                  </option>
                </Select2>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('contacts.placeholder.district') }} </label>
                    <input type="text" v-model="form.district" class="form-control form-control-solid"
                          :placeholder="$t('contacts.placeholder.district')">
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('contacts.placeholder.block') }} </label>
                    <input type="text" v-model="form.block" class="form-control form-control-solid"
                          :placeholder="$t('contacts.placeholder.block')">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('contacts.placeholder.square') }} </label>
                    <input type="text" v-model="form.square_number" class="form-control form-control-solid"
                          :placeholder="$t('contacts.placeholder.square')">
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('contacts.placeholder.plot') }} </label>
                    <input type="text" v-model="form.plot" class="form-control form-control-solid"
                          :placeholder="$t('contacts.placeholder.plot')">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('contacts.placeholder.house') }} </label>
                    <input type="text" v-model="form.house" class="form-control form-control-solid"
                          :placeholder="$t('contacts.placeholder.house')">
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('contacts.adress') }} </label>
                    <input v-model="form.street" :placeholder="$t('contacts.placeholder.street')" type="text" class="form-control form-control-solid">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="mb-3">{{ $t('contacts.placeholder.zipcode') }} </label>
                    <input type="text" v-model="form.zipcode" class="form-control form-control-solid"
                          :placeholder="$t('contacts.placeholder.zipcode')">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
            <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <CreateArea :id="'create_area_form'+id" :parent="'contactAddressModal'+id" :country="form.country" @load="selectArea"/>
</template>

<script>

import {mapGetters, mapActions} from 'vuex'
import Select2 from "@/components/Select2.vue";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import CreateArea from './Area/CreateArea.vue';

export default {
  components: {Select2, RequiredText, Button, CreateArea},

  props: {
    address: {type: Object, required: true},
    getCountries: {type: Array, required: false},
    action: {type: String, default: 'create'},
    contact: {type: String, default: ''},
    id: {type: String, default: "1"}
  },

  data() {
    return {
      form: {
        id: null,
        gender: null,
        street: null,
        street2: null,
        area_id: null,
        zipcode: null,
        country: null,
        square_number: null,
        house: null,
        district: null,
        block: null,
        plot: null
      },
      isLoading: false
    }
  },

  watch: {
    '$i18n.locale': function (value) {
      this.$nextTick(() => {
        $(".kt_select2").select2({
          placeholder: this.$t('auth.country')
        });
      })
    },
    address: function (value) {
      this.form = value
    }
  },

  mounted() {
    this.form = this.address
    this.loadCities()
    this.loadAreas()
    $("#kt_hbd").flatpickr();

    KTApp.initSelect2()

    $('#country'+ this.id).select2()

    $('body select[data-control="select2"]').select2()


    $('body select[data-control="select2"]').change((e) => {
      switch (e.target.name) {
        case 'country' + this.id :
          this.form.country = e.target.value
          break;
        case 'gender' + this.id :
          this.form.gender = e.target.value
          break;
      }
    });

    $('#contactAddressModal' + this.id).on('shown.bs.modal', (e) => {
      KTApp.initSelect2()
      $('body select[data-control="select2"]').select2()

    })

  },

  computed: {
    contactNamePlaceholder() {
      return i18n.global.t('contacts.fullname')
    },
    ...mapGetters('cities', [
      'getCities'
    ]),
    ...mapGetters('areas', [
      'getAreas'
    ]),

    cites () {
      if(this.form.country)
        return this.getCities.filter(el => el.country_id == this.form.country)

      return this.getCities
    },
    areas () {
      if(this.form.country)
        return this.getAreas.filter(el => el.country_id == this.form.country)

      return this.getAreas
    }
  },

  methods: {
    ...mapActions('cities', [
      'loadCities'
    ]),
    ...mapActions('areas', [
      'loadAreas'
    ]),
    ...mapActions('contacts', [
      'updateAddress'
    ]),

    pad(s) {
      return (s < 10) ? '0' + s : s;
    },

    convertDate(d) {
      return [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate()),].join('-')
    },

    timeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    },

    async saveForm() {
      this.isLoading = true

      try {
        let response = await this.updateAddress({address: this.form, contact: this.contact, action: this.action})
        $('#contactAddressModal' + this.id).modal('toggle')
        this.form = {
          id: null,
          gender: null,
          street: null,
          street2: null,
          city_id: null,
          area_id: null,
          zipcode: null,
          country: null,
          square_number: null,
          house: null,
          district: null,
          block: null,
          plot: null
        }

        this.emitValue(response.data.address)

        window.toastr['success'](i18n.global.t('notification.address_created'))
        this.isLoading = false
        return true

      } catch (e) {
        this.isLoading = false
      }
    },

    emitValue(address){
      if(this.action === 'edit' || this.action === 'default'){
        this.$emit('addressUpdated', address)
      }else {
        this.$emit('addressCreated', address)
      }
    },
    closeModal(){
      $('#contactAddressModal' + this.id).modal('toggle')
    },
    openAreaModal(){
      this.closeModal()
      $('#create_area_form' + this.id).modal('toggle');
    },
    selectArea(area){
      this.loadAreas()
      this.form.area_id = area
    }
  },


}
</script>

<style scoped>

.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #1e1e2d;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #1e1e2d;
}

.select2-container--bootstrap5 .select2-selection--multiple:not(.form-select-sm):not(.form-select-lg) {
    padding-top: calc((2.5rem + 2px - 0.8rem)/ 2);
    padding-bottom: calc((2.5rem + 2px - 0.8rem)/ 2);
}
.select2-container .select2-selection--multiple, .kt_select2{
  min-height: 44.89px !important;
}

.select-container {
  position: relative;
}

.input-group-text {
    display: flex;
    align-items: center;
    padding: 0.25rem;
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--bs-secondary);
    text-align: center;
    white-space: nowrap;
    background-color: #f5f8fa;
    border: 1px solid #e4e6ef;
    border-radius: 0.475rem;
}
</style>
